module.exports = __webpack_public_path__ + "static/media/error-404.3229ab88.png";